import React, { useState, useEffect } from 'react';
import { Card, Form, Button, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import BotaoFlutuante from '../components/Button/BotaoFlutuante';
import RenderizarProduto from '../components/Utils/RenderizarProduto';
import SelecionarTipoDeContato from '../components/Utils/SelecionarTipoDeContato';
import { useProvider, Toast } from '../context/MenuProvider';
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
dayjs.locale("pt-br");


const AniversarioCliente = () => {
    const navigate = useNavigate();
    const [query, setQuery] = useState('');
    const [clientes, setClientes] = useState([]);
    const [filtroTipoContato, setFiltroTipoContato] = useState('');
    const [nextUrl, setNextUrl] = useState(null);
    
    const {
      crud,
      setTitle
    } = useProvider();
    
    setTitle("Aniversariantes")

    const { get, loading, post, urlBase } = crud || {};

    // Função para buscar clientes na API
    const buscarClientes = async (novaBusca = false) => {
        const data = new Date().toLocaleString('pt-BR', {
          timeZone: 'America/Sao_Paulo',
          day: '2-digit',
          month: '2-digit',
        });
        
        const [dia, mes] = data.split('/');
        
        const url = `/gvendas/clientes/?contato__aniversario__day__exact=${dia}&contato__aniversario__month__exact=${mes}&ordering=nome_do_cliente&ativo=true`;
        
        if (novaBusca) {
            setClientes([]);
            setNextUrl(null);
        } else if (nextUrl) {
            url = nextUrl;
        } else {
            url = null;
        }

        if (!url) return;
        try{
          const response = await get(url, 'pagina');
          if(response && response?.length){
            const novosClientes = response[0].results;
            setClientes((clientesAnteriores) => novaBusca ? novosClientes : [...clientesAnteriores, ...novosClientes]);
            setNextUrl(response[0].next);
          }
          
        }catch(err){

        }finally{
          
        }
    };
    
    const enviarWhatsApp = async (e) => {
      if (!e.telefone){
        Toast.fire({
            icon: "error",
            title: `${e.is_cliente?'Cliente':'Contato'} sem WhatsApp cadastrado`
        });
        return
      }
      if (!filtroTipoContato){
        // Toast.fire({
        //     icon: "warning",
        //     title: `Selecione um tipo de mensagem`
        // });
        const telefone = `55${e.telefone.replace(/\D/g, '')}`;
        const url = `whatsapp://send?${telefone ? `phone=${telefone}&` : ""}text=`;
        //addRelacionamento(e, response[0].response)
        window.open(url);
        return
      }
      //alert(`Tipo: ${filtroTipoContato}/n${JSON.stringify(e)}`)
      const instrucoes = `
      Nome do cliente: ${e.nome_do_cliente.trim().split(' ')[0]}
      Valor total pago: ${e.total_pago},
      Valor total à pagar: ${e.total_aberto},
      Valor total atrasado: ${e.total_atrasado},
      total de compras: ${e.compras_count},
      última compra: ${e.tempo_ultima_compra},
      `;
      //alert(instrucoes)
      
      try{
        const data = {
          "instrucoes": `${instrucoes}. sempre em primeira pessoa, resposta curta e direta para WhatsApp, sempre falar o nome do cliente`,
          "contexto": filtroTipoContato
        }
        const response = await post(data, `/assistente-ia/openai-chat/gerar-mensagem/`);
        if (response){
          Swal.fire({
            title: `${e.full_name}`,
            text: response[0].response,
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: "Enviar",
            cancelButtonText: "Cancelar",
            denyButtonText: `Refazer`
          }).then(async (result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              const mensagem = encodeURIComponent(response[0].response);
              const telefone = `55${e.telefone.replace(/\D/g, '')}`;
              const url = `whatsapp://send?${telefone ? `phone=${telefone}&` : ""}text=${mensagem}`;
              //addRelacionamento(e, response[0].response)
              window.open(url);
            } else if (result.isDenied) {
              enviarWhatsApp(e);//reescrever a mensagem
            }
          });
        }
      }catch(err){
        
      }finally{
        
      }
    }
    
    const addRelacionamento = async (e, mensagem) => {
      try{
        const date = new Date();
        const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
          .toISOString()
          .split('.')[0];
        const data = {
          "titulo": `Feliz Aniversário ${e.nome_do_cliente}`,
          "data": localDate,
          "observacoes": mensagem,
          "is_realizado": true,
          "clientes": [e.id]
        }
        
        const response = await post(data, `/gvendas/agendas/`);
        if (response){
          //alert(JSON.stringify(response))
        }
        
      }catch(err){
          //alert(`Erro: ${JSON.stringify(err)}`)
      }finally{
        
      }
    }
    
    
    // Carrega os clientes ao montar o componente ou aplicar um novo filtro
    useEffect(() => {
      buscarClientes(true);
    }, [query]);

    // Detecta o fim da página para carregar mais clientes
    useEffect(() => {
        const handleScroll = () => {
            if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
                if (!loading) buscarClientes();
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [loading, nextUrl]);

    return (
        <>
            <div className="">
                <Form>
                    <SelecionarTipoDeContato tipoDeContatoId={filtroTipoContato} setTipoDeContatoId={setFiltroTipoContato} defaultText="Selecione um tipo de mensagem" adicionalText="Padrão" adicionalValue="Escreva uma mensagem para cliente que está de aniversário hoje" label="Tipo de Mensagem" search="aniversário"/>
                </Form>
                
                <div className="list-group mt-3">
                  {clientes.length > 0 ? (
                    clientes.map((x) => (
                      <RenderizarProduto
                        key={x.id} // É importante sempre adicionar uma chave única ao renderizar uma lista
                        onClick={() => enviarWhatsApp(x)} // Chamada correta da função no onClick
                        icon="bi-person text-muted"
                        text1={`Última Compra: ${x.data_ultima_compra?dayjs(x.data_ultima_compra).format("DD/MM/YYYY dddd"):'Nunca'}`}
                        titulo={x.nome}
                        text2={`${x.numero_de_compras > 0 ? (parseFloat(x.total_em_compras) - parseFloat(x.total_aberto)).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) + ' pago' : ''} ${x.total_aberto > 0 ? ' e ' + x.total_aberto.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) + ' em aberto' : ''}`}
                      />
                    ))
                  ) : (
                    !loading && <p className="text-center text-muted">Nenhum cliente encontrado.</p>
                  )}
                  
                  {loading && <p className="text-center"><Spinner animation="border" /></p>}
                  
                  {nextUrl && !loading && (
                    <Button variant="secondary" onClick={() => buscarClientes(false)} className="mt-2">
                      Buscar mais...
                    </Button>
                  )}
                </div>
            </div>
        </>
    );
};

export default AniversarioCliente;